import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ContextualHelpComponent } from '../contextual-help/contextual-help.component';
import { ContextualHelpDTO, ContextualHelpModel } from 'src/app/models/contextualHelp';
import { SearchService } from 'src/app/services/search.service';
import { Subject } from 'rxjs';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { HttpClient } from '@angular/common/http';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { ModalConfirmationMessageComponent } from 'src/app/utils/modals/modal-confirmation-message/modal-confirmation-message.component';
import { ModalMessageComponent } from 'src/app/utils/modals/modal-message/modal-message.component';
import { ModalControlService } from 'src/app/services/modal-control.service';

@Component({
  selector: 'app-create-or-edit-contextual-help',
  templateUrl: './create-or-edit-contextual-help.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class CreateOrEditContextualHelpComponent implements OnInit{
  @Input() contextualHelp :ContextualHelpModel = new ContextualHelpModel();
  @Input() edit: boolean;
  searchExpanded : boolean = false;
  public onClose: Subject<ContextualHelpModel>
  constructor(public bsModalRef : BsModalRef,
    public searchService: SearchService,
    public endpointService: EndpointsService,
    public http: HttpClient,
    public uiBlock: UiBlockService,
    public modalControlService: ModalControlService
    ){

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  save(){
    this.uiBlock.startBlock("Saving changes.")
    this.http.post(
      this.endpointService.contextualHelpUpdate,
      this.contextualHelp,
      this.endpointService.httpOptions
      ).subscribe((result:ContextualHelpModel) =>{
        this.onClose.next(result);
        this.bsModalRef.hide();
        this.uiBlock.stopBlock();
        this.modalControlService.showMesssageModal("Contextual Help Stored","Changes were stored successfully","OK");
      },
      (error:any)=>{
        this.modalControlService.showMesssageModal("Error","Changes were not stored.","OK");
        this.uiBlock.stopBlock();
      }
      )
  }
  selectEnabled(){
    this.contextualHelp.isEnabled= !this.contextualHelp.isEnabled;
  }

}
